import produce from 'immer';
import type { ThemePreference } from '../actions/theme';

export interface ThemeState {
  preference: ThemePreference;
}

export const initialState: ThemeState = {
  preference: 'light',
};

export const reducer = produce((state: ThemeState, action: { type: string; payload?: any }) => {
  switch (action.type) {
    case 'app/theme/SET_PREFERENCE': {
      state.preference = action.payload.preference;
      break;
    }
  }
}, initialState);
